// A page's path with a slug at its end: what comes before the slug is muted, so the slug itself stands out.
const SlugPath = ({ path }: { path: string }) => {
    const slugStart = path.lastIndexOf('/') + 1;
    return (
        <>
            <span className="text-text-muted">{path.slice(0, slugStart)}</span>
            <span className="text-text">{path.slice(slugStart)}</span>
        </>
    );
};

export default SlugPath;
